// Patch 37 · if a page crashes, show a small "something went wrong" box instead of a black screen,
// and send the error to Admin → Errors. Keyed by the address, so moving to another page clears it.
import { Component } from "react";
import { reportError } from "@/lib/errorReporter";

const TXT = {
  pt: { title: "Algo correu mal", body: "Esta página teve um erro. Já avisámos a equipa.", reload: "Recarregar", home: "Ir para o início" },
  en: { title: "Something went wrong", body: "This page hit an error. The team has been told.", reload: "Reload", home: "Go to home" },
};

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    try {
      reportError(`[page] ${error?.message || error}`, `${error?.stack || ""}\n${info?.componentStack || ""}`);
    } catch {
      /* never let reporting break the page */
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    let lang = "pt";
    try {
      lang = localStorage.getItem("tierpt_lang") === "en" ? "en" : "pt";
    } catch {
      /* storage blocked */
    }
    const L = TXT[lang];
    return (
      <div className="min-h-[60vh] grid place-items-center px-5 pt-24" role="alert" data-testid="page-error">
        <div className="max-w-sm w-full text-center border border-amber-500/25 bg-[#16161b] rounded-sm p-6">
          <div className="font-display text-2xl font-black uppercase text-amber-300">{L.title}</div>
          <p className="text-sm text-stone-400 mt-2">{L.body}</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center mt-5">
            <button type="button" onClick={() => window.location.reload()} className="btn-gold px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.18em] rounded-sm">
              {L.reload}
            </button>
            <a href="/" className="border border-white/15 text-stone-200 px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.18em] rounded-sm">
              {L.home}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
